import React from "react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

interface AddressLabelProps extends React.ComponentPropsWithoutRef<typeof Label> {
  required?: boolean;
}

// todo: investigate other uses of Label component and see if the required prop and similar styling can  be incorporated into the Label component itself
export function AddressLabel({
  className,
  required,
  children,
  ...props
}: AddressLabelProps) {
  return (
    <Label
      className={cn(className)}
      {...props}
    >
      {children}
      {required && (
        <sup className="text-destructive text-sm font-medium ml-0.5">*</sup>
      )}
    </Label>
  );
}
